import { Controller } from 'stimulus'
import { useDispatch } from 'stimulus-use'

export default class extends Controller {
  static targets = ['select', 'selectIcon', 'selectContainer', 'checkbox', 'optionVisibleOnDisableOnly']

  static values = {
    originalSelectedValue: String,
    hideClass: String,
    cached: Boolean
  }

  initialize() {
    if (!this.cachedValue) {
      useDispatch(this)
      this.originalSelectedValueValue = this.selectTarget.value

      // Disable select if the select has selected the value intended to be visible only when the select is disabled.
      this.updateSelectLook()

      this.selectTarget.addEventListener('change', () => {
        this.originalSelectedValueValue = this.selectTarget.value
      })
      this.dispatch('initialized')
    }
  }

  disconnect() {
    this.cachedValue = true
  }

  updateSelectLook() {
    if (this.checkboxTarget.checked) {
      this.disableSelect(false)
      if (this.isOriginalSelectedValueTheDisabledOne) {
        this.selectTarget.value = this.selectTarget.options[0].value
      } else {
        this.selectTarget.value = this.originalSelectedValueValue
      }
    } else {
      this.selectTarget.value = this.optionVisibleOnDisableOnlyTarget.value
      this.disableSelect(true)
    }
  }

  disableSelect(shouldDisable) {
    if (shouldDisable) {
      this.selectTarget.setAttribute('disabled', 'disabled')
      this.selectContainerTarget.classList.add('opacity-50')
    } else {
      this.selectTarget.removeAttribute('disabled')
      this.optionVisibleOnDisableOnlyTarget.classList.add(this.hideClassValue)
      this.selectContainerTarget.classList.remove('opacity-50')
    }
  }

  get isOriginalSelectedValueTheDisabledOne() {
    return this.originalSelectedValueValue === this.optionVisibleOnDisableOnlyTarget.value
  }
}
